import React, { useState, useEffect, useContext } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ChooseDateTime = ({
  selectedStaff,
  selectedServices,
  selectedTime,
  availableTimes,
  unavailability,
  shopClosedDays,
  shopClosedWeekDays,
  setSelectedTime,
  setSelectedDate,
  selectedDate,
}) => {
  const [excludeDates, setExcludeDates] = useState([]);
  const [holidaysDates, setHolidaysDates] = useState([]);

  // When date changes, fetch available time slots
  const getExecludeDates = (month, year) => {
    const excludeDates = [];
    const holidays = [];
    const startDate = new Date(
      month == 0 ? year - 1 : year,
      month == 0 ? 11 : month - 1,
      20,
    );
    const endDate = new Date(
      month == 11 ? year + 1 : year,
      month == 11 ? 0 : month + 1,
      20,
    );
    const today = new Date();
    const date = startDate;
    while (date >= startDate && date <= endDate) {
      const isBeforeToday =
        date.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0);
      const isClosedWeekday = shopClosedWeekDays.includes(date.getDay());
      const isSpecialClosed = shopClosedDays.find(
        (d) => new Date(d.date).getTime() === new Date(date).getTime(),
      );
      const isUnAvailable = unavailability.some(
        (d) =>
          new Date(d.date).getTime() === new Date(date).getTime() &&
          d.startTime == null &&
          d.endTime == null,
      );
      if (isBeforeToday || isClosedWeekday || isUnAvailable) {
        excludeDates.push(new Date(date));
      }

      if (isSpecialClosed) {
        excludeDates.push(new Date(isSpecialClosed.date));
        holidays.push({
          date: isSpecialClosed.date,
          holidayName: isSpecialClosed.reason,
        });
      }

      date.setDate(date.getDate() + 1);
    }
    setHolidaysDates(holidays);
    setExcludeDates(excludeDates);
  };

  useEffect(() => {
    if (unavailability && selectedStaff) {
      const date = new Date();
      getExecludeDates(date.getMonth(), date.getFullYear());
    }
  }, [unavailability]);

  return (
    <div className="row">
      <h3 className=" col-12 mb-4">Choose Date & Time</h3>
      {/* Date Picker */}
      <div className="col-12 col-md-6 mb-4">
        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          excludeDates={excludeDates}
          holidays={holidaysDates}
          onMonthChange={(date) =>
            getExecludeDates(date.getMonth(), date.getFullYear())
          }
          inline
        />
      </div>
      <div className="col-12  col-md-6">
        {/* Time Slots */}
        {availableTimes.length > 0 && (
          <div>
            <h5>Available time slots:</h5>
            <div className="d-flex flex-wrap gap-2 mt-2">
              {availableTimes.map((time) => (
                <button
                  key={time}
                  className={`btn ${
                    selectedTime === time
                      ? "btn-primary"
                      : "btn-outline-secondary"
                  }`}
                  onClick={() => setSelectedTime(time)}
                >
                  {time}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChooseDateTime;
